import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import React, { useEffect, useRef, useState } from "react";
import { blackListCountryRequest, institutionRegisteredRetryRequest } from "../common/customServiceCall/serviceCall";
import { InputText } from "primereact/inputtext";
import { useSelector } from "react-redux";
import { Button } from "primereact/button";
import { format } from "date-fns";
import CountryFlag from "react-country-flag";

const InstitutionRegisteredForRetry = () => {
  const userDetails = useSelector((state) => state.login.userDetails);
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [blacklist, setBlacklist] = useState([] || null);
  const [currency, setCurrency] = useState("");

  const fetchData = async () => {
    setLoading(true);


    try {
      const response = await institutionRegisteredRetryRequest(
        "get",
        `api/v1/cbfailuremapper/institution/q`
      );

      if (response.code === "00") {
        setBlacklist(response.data || []); // Set data or empty array
      } else {
        setBlacklist([]); // No data, clear the table
        console.error("Failed to fetch data:", response.message);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currency]); // Re-fetch data when filters change



  const getSearchedData = () => {
    fetchData(); // Re-fetch the data with the updated filters
  };

    const countryBodyTemplate = (rowData) => {
      return (
        <div style={{ display: "flex", alignItems: "center" }}>
          <CountryFlag
            countryCode={rowData.code}
            svg
            style={{ width: "25px", height: "15px", marginRight: "8px" }}
          />
          {rowData.code}
        </div>
      );
    };

  const dateTemplate = (rowData) => {
    return <p>{format(new Date(rowData.createdAt), "yyyy-MM-dd HH:mm:ss")}</p>;
  };

  const floatLabel = {
    fontWeight: "500",
    color: "rgb(153, 153, 153)",
    fontSize: "12px",
  };

  const labelStyle = {
    paddingLeft: "10px",
    fontSize: "12px",
    color: "rgb(92, 74, 181)",
    fontWeight: "500",
  };

  return (
    <div>
      {" "}
      <section className="p-my-4 p-md-12 p-xl-12">
        <Toast ref={toast} />

        <div className="p-grid p-fluid p-mb-4">
          <div
            className="p-col-12 p-sm-12 p-md-10 p-lg-10 p-xl-10 p-md-offset-1 p-lg-offset-1 p-xl-offset-1"
            style={{ textAlign: "center" }}
          >
            <span className="p-tag custom-heading">
              Institution Registered For Retry
            </span>
          </div>
        </div>

        <div className="card">
          {loading ? (
            <div style={{ textAlign: "center", padding: "20px" }}>
              <ProgressSpinner
                style={{
                  display: userDetails.showLoader,
                  width: "40px",
                  height: "40px",
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  bottom: "50%",
                  right: "50%",
                  zIndex: "1111111111",
                }}
                strokeWidth="3"
                animationDuration=".5s"
              />
            </div>
          ) : (
            <DataTable
              value={blacklist}
              paginator
              rows={5}
              rowsPerPageOptions={[5, 10, 25, 50]}
              tableStyle={{ minWidth: "60rem" }}
              className="p-datatable-responsive-demo"
            >
              <Column
                field="id"
                header="Id"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>
              <Column
                field="institutionId"
                header="Institution Id"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>

              <Column
                field="institutionName"
                header="Institution Name"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>

              <Column
                field="transactionSystemId"
                header="Transaction System Id"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>
              <Column
                field="retryOn"
                header="Retry On"
                style={{ width: "25%", fontSize: "13px" }}
              ></Column>
              <Column
                field="createdAt"
                header="Created At"
                style={{ width: "25%", fontSize: "13px" }}
                body={dateTemplate}
              ></Column>
            </DataTable>
          )}
        </div>
      </section>
    </div>
  );
};

export default InstitutionRegisteredForRetry;
